module.exports = __webpack_public_path__ + "509089197820ddaf3bfee3fc9600a746.jpg";